import type { UpdateNotificationReadStatus200SourceSourceUserAllOf } from './updateNotificationReadStatus200SourceSourceUserAllOf';
import type { UpdateNotificationReadStatus200SourceSourceUserAllOfTwo } from './updateNotificationReadStatus200SourceSourceUserAllOfTwo';

/**
 * 알림을 발생시킨 사용자 정보
 */
export type UpdateNotificationReadStatus200SourceSourceUser = UpdateNotificationReadStatus200SourceSourceUserAllOf & UpdateNotificationReadStatus200SourceSourceUserAllOfTwo;
